import React from "react";
import { Layout, Menu, Breadcrumb, Icon } from "antd";
import "./style.css";
const { SubMenu } = Menu;
const { Header, Content, Sider } = Layout;
import { Route } from "react-router-dom";
import PropertyList from "./PropertyList/index";
import FundList from "./FundList";
import PropertySetting from "./PropertySetting";
import Home from "./Home";
import { allItem } from "./Item-render";

interface Props {
  history: any;
}
const index = (props: Props) => {
  const getUrl = (e: any) => {
    if (e.key === "home") {
      return props.history.push(`/property`);
    }
    props.history.push(`/property/${e.key}`);
  };

  const pages = [
    {
      id: "home",
      dom: Home,
    },
    {
      id: "propertyList",
      dom: PropertyList,
    },
    {
      id: "fundList",
      dom: FundList,
    },
    {
      id: "propertySetting",
      dom: PropertySetting,
    },
  ];

  const routes = pages.map((item: any, index: any) => {
    if (item.id === "home") {
      return <Route key={index} exact path="/property" component={Home} />;
    }
    return (
      <Route key={index} path={`/property/${item.id}`} component={item.dom} />
    );
  });

  const menu_item = allItem.map((item: any) => {
    if (item && item.MenuContent) {
      const { id, MenuIcon, title, MenuContent } = item;
      return (
        <SubMenu
          key={id}
          title={
            <span className="asideContent">
              {MenuIcon}
              <span className="asideTitle outer">{title}</span>
            </span>
          }
        >
          {MenuContent.map((imte2) => {
            return (
              <Menu.Item key={`${id}/${imte2.id}`}>
                <span className="asideContent">
                  <span className="asideTitle">{imte2.title}</span>
                </span>
              </Menu.Item>
            );
          })}
        </SubMenu>
      );
    } else if (item) {
      return (
        <Menu.Item key={item.id}>
          <div className="asideContent">
            {item.MenuIcon}
            <span className="asideTitle outer">{item.title}</span>
          </div>
        </Menu.Item>
      );
    } else {
      return;
    }
  });

  return (
    <Layout className="property">
      <Layout>
        <Sider width={250} style={{ background: "#fff" }}>
          <Menu
            mode="inline"
            defaultSelectedKeys={["home"]}
            defaultOpenKeys={["propertyList"]}
            style={{ height: "100%", borderRight: 0 }}
            onClick={getUrl}
          >
            {menu_item}
          </Menu>
        </Sider>
        <Layout style={{ padding: "0 24px 24px" }}>
          <Content
            style={{
              background: "#fff",
              padding: 24,
              margin: 0,
              minHeight: 280,
            }}
          >
            {routes}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default index;
